import { render } from "./Disinfect.vue?vue&type=template&id=cf7251f2&scoped=true"
import script from "./Disinfect.vue?vue&type=script&lang=js"
export * from "./Disinfect.vue?vue&type=script&lang=js"

import "./Disinfect.vue?vue&type=style&index=0&id=cf7251f2&lang=scss"
import "./Disinfect.vue?vue&type=style&index=1&id=cf7251f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf7251f2"

export default script